import { AccountingWorkpadsDraftsService } from '@festina/life-general-types/life/services/AccountingWorkpadsDraftsService'
import { useFestinaMutation } from '@festina-life/authentication'

const method =
  AccountingWorkpadsDraftsService.workPadsDraftsServiceDeleteDeleteDraftWorkPad
type MethodParam = Omit<Parameters<typeof method>[0], `x${string}`>

type Props = {
  tenantId: string
}

export const useDeleteDraftWorkPad = ({ tenantId }: Props) =>
  useFestinaMutation({
    component: 'life',
    roles:
      AccountingWorkpadsDraftsService.workPadsDraftsServiceDeleteDeleteDraftWorkPad_roles,
    isScenario: false,
    mutateFunction: async (arg: MethodParam) => {
      await method({
        xTenantId: tenantId,
        ...arg,
      })
    },
  })
